import type { HexColor } from "../hex-color/hex-color";
import type { HSLA } from "../hsla-color/hsla-color";
import { hslaToRgba } from "./hsla-to-rgba";
import { rgbaToHex } from "./rgba-to-hex";

const hslaToHex = (color: HSLA): HexColor => {
    const { red, green, blue, alpha } = hslaToRgba(
        color.hue,
        color.saturation,
        color.light,
        color.alpha,
    );
    return rgbaToHex({ red, green, blue, alpha });
};

export { hslaToHex };
